import { customizeError, formatDNI } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { checkIfForeignDni } from '../../modules/utils/helpers'
import { getCompanyManagersSii } from '../../services/sii'
import { getCompanyManagersAffidavit } from '../../services/seller'

export const GET_COMPANY_MANAGERS = 'GET_COMPANY_MANAGERS'
export const GET_COMPANY_MANAGERS_ERROR = 'GET_COMPANY_MANAGERS_ERROR'
export const GET_COMPANY_MANAGERS_SUCCESS = 'GET_COMPANY_MANAGERS_SUCCESS'
export const onGetCompanyManagers = makeActionCreator(GET_COMPANY_MANAGERS)
export const onGetCompanyManagersError = makeActionCreator(GET_COMPANY_MANAGERS_ERROR, 'payload')
export const onGetCompanyManagersSuccess = makeActionCreator(GET_COMPANY_MANAGERS_SUCCESS, 'payload')
export const onGetCompanyManagersThunk =
  ({ payload, callback = () => undefined }) =>
  async (dispatch, getState) => {
    dispatch(onGetCompanyManagers())

    try {
      const { sellerType } = getState().basicSellerInformation
      const { loading } = getState().companyAdministration

      if (sellerType === 'natural') {
        return dispatch(
          onGetCompanyManagersSuccess({
            managers: [],
            source: 'sii'
          })
        )
      }

      const isForeign = checkIfForeignDni(payload.dni)
      const resp = await getCompanyManagersAffidavit({
        actionType: GET_COMPANY_MANAGERS,
        dni: payload.dni
      })

      // If we don't find data in the affidavit, try with SII (except for foreigners)
      if ((!isForeign && resp === undefined) || !loading) {
        return callback()
      }

      return dispatch(
        onGetCompanyManagersSuccess({
          managers: resp?.data?.payload?.map(manager => {
            return {
              dni: manager.tiponacionalidad === 1 ? formatDNI(manager.rut).toUpperCase() : manager.rut.toUpperCase(),
              name: [[manager.nombre, manager.apellidoP].join(' ').trim(), manager.apellidoM].join(' ').trim(),
              position: manager.cargo
            }
          }),
          source: 'affidavit'
        })
      )
    } catch (error) {
      // FIXME: this checks should goes inside the factoryService implementation.
      // It will be fixed in v2 of react-kit.
      if (error?.originalError?.code === 'ERR_CANCELED') {
        return
      }

      let reason
      switch (error.code) {
        case 401:
          reason = 'UNAUTHORIZED_ERROR'
          break
        case 403:
          reason = 'FORBIDDEN_ERROR'
          break
        case 404:
          reason = 'NOT_FOUND_ERROR'
          break
        default:
          reason = 'SOMETHING_WENT_WRONG_ERROR'
          break
      }

      return dispatch(
        onGetCompanyManagersError({
          error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
        })
      )
    }
  }

export const onGetCompanyManagersSiiThunk = payload => async dispatch => {
  dispatch(onGetCompanyManagers())

  try {
    const { data } = await getCompanyManagersSii({
      actionType: GET_COMPANY_MANAGERS,
      dni: payload.dni
    })

    return dispatch(
      onGetCompanyManagersSuccess({
        managers: data?.payload?.representantes?.map(manager => {
          return {
            dni: formatDNI(manager.rut).toUpperCase(),
            name: [[manager.nombre, manager.apellidoPaterno].join(' ').trim(), manager.apellidoMaterno]
              .join(' ')
              .trim(),
            position: 'Representante Legal'
          }
        }),
        source: 'sii'
      })
    )
  } catch (error) {
    // FIXME: this checks should goes inside the factoryService implementation.
    // It will be fixed in v2 of react-kit.
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }

    return dispatch(
      onGetCompanyManagersError({
        error: customizeError({
          originalError: error?.originalError,
          code: error.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}
